import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated";
import Select, {createFilter} from "react-select";

class PatternConsequenceInput extends Component {
    state = {
        pattern_consequences: [],
        isLoading: true,
        isError: false
    };

    componentDidMount() {
        if (this.props.pattern_consequences) {
            this.setState({ pattern_consequences: this.props.pattern_consequences, isLoading: false });
        } else {
            this.fetchPatternConsequences();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.pattern_consequences !== this.state.pattern_consequences) {
            this.setState({ pattern_consequences: this.props.pattern_consequences, isLoading: false });
        }
    }

    fetchPatternConsequences = () => {
        axios.get(apiUrl + 'PatternConsequences/getPatternConsequences')
            .then(response => {
                this.setState({ pattern_consequences: response.data, isLoading: false });
            })
            .catch(error => {
                console.error('Error fetching consequences:', error);
                this.setState({ isError: true, isLoading: false });
            });
    };

    render() {
        const { pattern_consequences, isLoading, isError } = this.state;
        const { pattern_consequence_filter, patternConsequencesUpdate, updatePage, closePatternDetails } = this.props;

        // Handle errors
        if (isError) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Error loading consequences. Please try again later."
                />
            );
        }

        // Handle loading state
        if (isLoading) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Loading consequences..."
                />
            );
        }

        const options =
             pattern_consequences.map(pattern_consequence => ({
                value: pattern_consequence.consequence_id,
                label: pattern_consequence.consequence_title,
                description: pattern_consequence.consequence_description,
                color: '#9999FF'
            }));
        const animatedComponents = makeAnimated();

        const defaultOptions = pattern_consequence_filter.map(pattern_consequence_id => {
            return options.find(option => option.value === pattern_consequence_id) || { value: 0, label: "Invalid pattern consequence id", color: '#9999FF' };
        });

        const consequence_description_wrapper = (description = '""') =>  ({
           ':after': {
                content: description ? ('" - ' + description + '"') : '',
                fontSize: 14,
           },
        });

        return (
            <Select
                isMulti
                isSearchable
                styles={{
                    option: (styles, { data }) => {
                        return {
                            ...styles,
                            ...consequence_description_wrapper(data.description)
                        };
                    },
                }}
                filterOption={createFilter({
                   stringify: option => `${option.label} ${option.value} ${option.data.description}`
                })}
                options={options}
                value={defaultOptions}
                closeMenuOnSelect={false}
                components={animatedComponents}
                placeholder={this.props.selectorText ?? "Select consequences for this pattern."}
                onChange={(val) => {
                    patternConsequencesUpdate(val);
                    updatePage(0);
                    closePatternDetails(null);
                }}
            />
        );
    }
}

export default PatternConsequenceInput;